module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "my-page-component"
  }, [_c('div', {
    staticClass: "inner"
  }, [(!_vm.loggedIn) ? _c('div', {
    staticClass: "login"
  }, [_c('Login', {
    on: {
      "login": _vm.login
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.loggedIn) ? _c('div', [_c('div', {
    staticClass: "my-name"
  }, [_c('h1', [_vm._v("Välkommen " + _vm._s(_vm.user.name1) + "!")]), _vm._v(" "), _c('p', [_vm._v("Ditt kundnummer är: " + _vm._s(_vm.user.addrlid))])]), _vm._v(" "), _c('div', {
    staticClass: "tab-buttons"
  }, [_c('div', {
    class: {
      'button--square': true, active: (_vm.activeTab === 'journey')
    },
    on: {
      "click": function($event) {
        return _vm.goToRouteWithName('my pages ' + 'journey')
      }
    }
  }, [_c('span', [_vm._v("Mina bokningar")])]), _vm._v(" "), _c('div', {
    class: {
      'button--square': true, active: (_vm.activeTab === 'bookings')
    },
    on: {
      "click": function($event) {
        return _vm.goToRouteWithName('my pages ' + 'bookings')
      }
    }
  }, [_c('span', [_vm._v("Tidigare")])]), _vm._v(" "), _c('div', {
    class: {
      'button--square': true, active: (_vm.activeTab === 'details')
    },
    on: {
      "click": function($event) {
        return _vm.goToRouteWithName('my pages ' + 'details')
      }
    }
  }, [_c('span', [_vm._v("Mina uppgifter")])]), _vm._v(" "), _c('div', {
    class: {
      'button--square': true, active: (_vm.activeTab === 'password')
    },
    on: {
      "click": function($event) {
        return _vm.goToRouteWithName('my pages ' + 'password')
      }
    }
  }, [_c('span', [_vm._v("Ändra lösenord")])]), _vm._v(" "), _c('div', {
    class: {
      'button--square': true, active: (_vm.activeTab === 'logout')
    },
    on: {
      "click": function($event) {
        return _vm.goToRouteWithName('my pages ' + 'logout')
      }
    }
  }, [_c('span', [_vm._v("Logga ut")])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-wrapper"
  }, [_c('router-view')], 1)]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-417ac41c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/MyPages/MyPage.vue
// module id = 938
// module chunks = 0